import { Button } from '@material-ui/core';
import SimpleDialog, { SimpleDialogProps } from 'Components/Dialogs/SimpleDialog';
import Loader from 'Components/Loader';
import { Formik } from 'formik';
import useAsyncTask from 'hooks/useAsyncTask';
import useToastMessage from 'hooks/useToastMessage';
import { IReactFormProps, MLFormContent } from 'react-forms';
import { AuthModel } from 'Models/Auth';
import { DefinitionsModel } from 'Models/Definitions';
import { Definition } from 'Models/Definitions/@types';
import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import * as yup from 'yup';

const validationSchema = yup.object<Pick<Definition, 'title'>>({
    title: yup.string().required('Required')
})

export interface DefinitionDialogFormProps extends Pick<SimpleDialogProps, 'open'> {

}

const FormSchema: IReactFormProps['config'] = [
    {
        type: 'text',
        valueKey: 'title',
        fieldProps: {
            fullWidth: true,
            label: 'Title',
            autoFocus: true
        }
    }
]

const DefinitionDialogForm: FC<DefinitionDialogFormProps> = (props) => {
    const { open } = props;
    const dispatch = useDispatch();
    const addDataTask = useAsyncTask(async (formData: Partial<Definition>) => dispatch(DefinitionsModel.postItem(formData)));

    const withToast = useToastMessage();

    const handleSubmit = async (formData: Pick<Definition, 'title'>) => {
        withToast(async () => {
            const userId = AuthModel.getUserId();
            if (!userId) throw new Error("User is not found");
            await addDataTask.run({ ...formData, authorId: userId });
        }, { successToastMessage: "Definition created" });
    }

    useEffect(() => {
        if (addDataTask.status === "SUCCESS") {
            handleClose();
        }
        //eslint-disable-next-line
    }, [addDataTask.status]);

    const handleClose = () => dispatch(DefinitionsModel.hideDialogForm());

    const loading = addDataTask.status === 'PROCESSING';

    return (

        <Formik<Pick<Definition, 'title'>>
            initialValues={{ title: '' }}
            onSubmit={handleSubmit}
            validationSchema={validationSchema}
        >
            {
                (formikProps) => {
                    return (
                        <SimpleDialog open={open} onClose={handleClose} title={'Add New Definition'} >
                            <form onSubmit={e => { e.preventDefault(); }} >
                                <MLFormContent
                                    formId={'definition-dialog-form'}
                                    schema={FormSchema}
                                    formikProps={formikProps}
                                    settings={{ verticalSpacing: 30 }}
                                />
                                <Button disabled={loading} type={'submit'} variant={'contained'} color={'primary'} fullWidth size={'large'} onClick={formikProps.submitForm} onSubmit={formikProps.submitForm} >
                                    {
                                        loading ?
                                            <Loader size={'xs'} /> :
                                            'SUBMIT'
                                    }
                                </Button>
                            </form>
                        </SimpleDialog>
                    )
                }
            }
        </Formik>
    )
}


export default DefinitionDialogForm